import { createContext, useContext } from "react";
import { IPolicyViewContext } from "./types";

export const PolicyViewContext = createContext<IPolicyViewContext | null>(null);

export const usePolicyViewContext = () => {
  const context = useContext(PolicyViewContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
